import { render, staticRenderFns } from "./DevolucionBodegaRevisar.vue?vue&type=template&id=4bc1f7ac&scoped=true"
import script from "./DevolucionBodegaRevisar.vue?vue&type=script&lang=js"
export * from "./DevolucionBodegaRevisar.vue?vue&type=script&lang=js"
import style0 from "./DevolucionBodegaRevisar.vue?vue&type=style&index=0&id=4bc1f7ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc1f7ac",
  null
  
)

export default component.exports